<template>
  <div class="package">
    <ul v-if="packageSubItems.length" class="list">
      <li v-for="(packageSubItem, index) in packageSubItems" :key="index" class="item">
        <icon icon="check" class="icon" /> {{ packageSubItem.name }}
      </li>
    </ul>
    <span v-if="partOfPackage" class="part-of-package">
      {{ i18n.t('/ProductBlocks/PartOfLabel') }} {{ partOfPackage.Name }}
    </span>
  </div>
</template>

<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import StoreConnector from '@/helpers/StoreConnector'

export default {
  components: {
    Icon,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    partOfPackage: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      allProducts: [],
    }
  },
  computed: {
    packageSubItems() {
      const packageSubItems = []
      this.item?.PackageSubItems?.forEach((packageSubItemId) => {
        const packageSubItem = this.allProducts?.find(
          (product) => product.OptionType_ID === packageSubItemId
        )
        if (packageSubItem)
          packageSubItems.push({
            name: packageSubItem.Name,
            id: packageSubItemId,
          })
      })
      return packageSubItems
    },
  },
  created() {
    StoreConnector.get('accessories/all', (data) => {
      this.allProducts = data
    })
  },
}
</script>

<style lang="scss" scoped>
.package {
  font-size: 0.9em;
}

.list {
  list-style: none outside;
}
.item {
  position: relative;
  padding-left: 1.25em;
}

.icon {
  position: absolute;
  width: 0.9em;
  left: 0;
}
</style>
